import React from 'react';
import './blog.css';

export const Blog = () => {
  return (
    <div>Blog</div>
  )
}

export default Blog;